import { switchMap } from 'rxjs/operators'

import getIframeDocument from '@newswebsiteapp/shared/lib/getIframeDocument'

import nightmodeSubject from '../nightmode/subject'

import { newsletterIframeLoadedObservable } from './observables'

newsletterIframeLoadedObservable
  .pipe(
    switchMap(
      () => nightmodeSubject,
      (iframe, nigntmodeEnabled) => ({
        iframe,
        nigntmodeEnabled,
      }),
    ),
  )
  .subscribe(({ iframe, nigntmodeEnabled }) => {
    const iframe$ = $(iframe)
    const applyNightmode = iframe$.data('apply-nightmode')

    if (applyNightmode === undefined) {
      return
    }

    const { body } = getIframeDocument(iframe)
    const body$ = $(body)

    if (nigntmodeEnabled) {
      body$.addClass('nightmode')
    } else {
      body$.removeClass('nightmode')
    }

    iframe$.removeClass('invisible')
  })
